export default __webpack_public_path__ + "static/media/trending.4e433728.svg";